module.exports = __webpack_public_path__ + "img/service.7ec57ec6.png";